import React from "react";
import { Button } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

export default function AddApplicantButton({ title, onClick }) {
  return (
    <Button
      variant="outlined"
      startIcon={<AddCircleOutlineIcon />}
      onClick={onClick}
      sx={{
        textTransform: "none",
        borderRadius: 2,
        borderColor: "#1A407D",
        padding: "8px 20px",
        color: "#1A407D",
        "&:hover": {
          borderColor: "#1A407D",
        },
        fontWeight: 600,
        fontSize: "14px",
      }}
    >
      {title}
    </Button>
  );
}
